<template>
	<c-dialog ref="dialog" title="常用功能配置" width="850" height="550" @resolve="submitHandle">
		<div class="route-config flex">
			<dl class="flex-grow">
				<dt class="flex-between-center"><p>固定功能</p><span>拖动可进行排序，最多10项</span></dt>
				<dd>
					<c-drag-sort v-model="selectedList" class="route-list flex-wrap">
						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="route-item flex-center-cross z-selected">
								<p class="ellipsis flex-grow">{{item.name}}</p>
								<a @click="removeRoute(index)"><i class="c-icon-cross"></i></a>
							</c-drag-item>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<div class="line"></div>
			<dl class="flex-grow">
				<dt class="flex-between-center"><p>可选功能</p><span>点击过的功能优先显示</span></dt>
				<dd><ul class="route-list flex-wrap"><li v-for="item in availableList" :key="item.route" class="route-item flex-center-cross" @click="addRoute(item)"><p class="ellipsis">{{item.name}}</p></li></ul></dd>
			</dl>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {selectedList: [], availableList: [], allRouteList: [], visitRouteList: []}
		},
		methods: {
			open(routeList) {
				this.$refs.dialog.open();
				this.allRouteList = routeList || [];
				this.request({
					url: '/workbench/frequent/config', data: {},
					success: data => {
						const routeMap = this.allRouteList.reduce((map, item) => {
							map[item.route] = item;
							return map;
						}, {});
						this.selectedList = (data.selected_list || []).map(item => routeMap[item.route_name]).filter(Boolean);
						this.visitRouteList = (data.visit_list || []).map(item => routeMap[item.route_name]).filter(Boolean);
						this.refreshAvailableList();
					}
				});
			},
			removeRoute(index) {
				this.selectedList.splice(index, 1);
				this.refreshAvailableList();
			},
			addRoute(item) {
				if (this.selectedList.length >= 10) {
					this.$message({message: '最多固定10项常用功能', type: 'warn'});
					return;
				}
				this.selectedList.push(item);
				this.refreshAvailableList();
			},
			refreshAvailableList() {
				const visitRouteMap = this.visitRouteList.reduce((map, item) => {
					map[item.route] = true;
					return map;
				}, {});
				const defaultList = this.allRouteList.filter(item => !visitRouteMap[item.route]);
				this.availableList = this.visitRouteList.concat(defaultList).filter(item => !this.selectedList.find(selected => selected.route === item.route));
			},
			submitHandle(stop, next) {
				stop();
				this.request({
					url: '/workbench/frequent/config/edit', data: {route_names: this.selectedList.map(item => item.route).join(',')}, loading: true,
					success: () => {
						next();
						this.$message({message: '保存成功'});
						this.$emit('resolve');
						this.$bus.$emit('updateQuick');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.route-config, dl {
		height: 100%;
	}
	.route-config {
		overflow: hidden;
	}
	dl {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}
	dt {
		height: 36px;
		padding: 0 12px 0 16px;
		background: #FAFAFA;
		span {
			font-size: 12px;
			color: #666;
		}
	}
	dd {
		flex: 1;
		min-height: 0;
		padding: 12px 14px;
		overflow-y: auto;
	}
	.route-list {
		gap: 10px;
	}
	.route-item {
		box-sizing: border-box;
		width: calc((100% - 20px) / 3);
		height: 35px;
		padding: 0 8px 0 12px;
		font-size: 13px;
		background: #F5F5F5;
		cursor: pointer;
		&:not(.z-selected):hover {
			color: #fff;
			background: var(--color-main);
		}
		&.z-selected {
			color: var(--color-main);
			background: #eef2ff;
			a {
				padding: 4px;
				color: #999;
				&:hover {
					color: #FF414A;
				}
			}
		}
	}
	.line {
		width: 6px;
		border: 1px solid #ddd;
		border-width: 0 1px;
		background: #F9F9F9;
	}
</style>
